<template>
  <v-card max-width="350">
    <v-card-title>Station {{ properties.ID }}</v-card-title>
    <v-card-text>
      <v-simple-table dense height="200" fixed-header>
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left">
              Name
            </th>
            <th class="text-left"/>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="item in headers"
              :key="item"
          >
            <td>{{ item }}</td>
            <td>{{ properties[item] }}</td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="showDialog">plot</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "geojsonPopup",
  props: ["properties", "mapboxPopup"],
  data: () => ({
    headers: ["Grobbodenanteil [%]", "Tongehalt [%]", "Schluffgehalt [%]", "Sandgehalt [%]", "pH in H20", "pH in CaCl", "Organischer Kohlenstoff [g/kg]", "Calciumkarbonat [g/kg]", "Gesamtstickstoff [g/kg]", "Phosphat [mg/kg]", "Kalium [mg/kg]", "Kationenaustauschkapazität [cmol(+)/kg]", "GPS_LAT", "GPS_LONG"],
    wavelength: ['455.0', '465.0', '475.0', '485.0', '495.0', '505.0', '515.0', '525.0', '535.0', '545.0', '555.0', '565.0', '575.0', '585.0', '595.0', '605.0', '615.0', '625.0', '635.0', '645.0', '655.0', '665.0', '675.0', '685.0', '695.0', '705.0', '715.0', '725.0', '735.0', '745.0', '755.0', '765.0', '775.0', '785.0', '795.0', '805.0', '815.0', '825.0', '835.0', '845.0', '855.0', '865.0', '875.0', '885.0', '895.0', '905.0', '915.0', '925.0', '935.0', '945.0', '955.0', '965.0', '975.0', '985.0', '995.0', '1005.0', '1015.0', '1025.0', '1035.0', '1045.0', '1055.0', '1065.0', '1075.0', '1085.0', '1095.0', '1105.0', '1115.0', '1125.0', '1135.0', '1145.0', '1155.0', '1165.0', '1175.0', '1185.0', '1195.0', '1205.0', '1215.0', '1225.0', '1235.0', '1245.0', '1255.0', '1265.0', '1275.0', '1285.0', '1295.0', '1305.0', '1315.0', '1325.0', '1335.0', '1345.0', '1355.0', '1365.0', '1375.0', '1385.0', '1395.0', '1405.0', '1415.0', '1425.0', '1435.0', '1445.0', '1455.0', '1465.0', '1475.0', '1485.0', '1495.0', '1505.0', '1515.0', '1525.0', '1535.0', '1545.0', '1555.0', '1565.0', '1575.0', '1585.0', '1595.0', '1605.0', '1615.0', '1625.0', '1635.0', '1645.0', '1655.0', '1665.0', '1675.0', '1685.0', '1695.0', '1705.0', '1715.0', '1725.0', '1735.0', '1745.0', '1755.0', '1765.0', '1775.0', '1785.0', '1795.0', '1805.0', '1815.0', '1825.0', '1835.0', '1845.0', '1855.0', '1865.0', '1875.0', '1885.0', '1895.0', '1905.0', '1915.0', '1925.0', '1935.0', '1945.0', '1955.0', '1965.0', '1975.0', '1985.0', '1995.0', '2005.0', '2015.0', '2025.0', '2035.0', '2045.0', '2055.0', '2065.0', '2075.0', '2085.0', '2095.0', '2105.0', '2115.0', '2125.0', '2135.0', '2145.0', '2155.0', '2165.0', '2175.0', '2185.0', '2195.0', '2205.0', '2215.0', '2225.0', '2235.0', '2245.0', '2255.0', '2265.0', '2275.0', '2285.0', '2295.0', '2305.0', '2315.0', '2325.0', '2335.0', '2345.0', '2355.0', '2365.0', '2375.0', '2385.0', '2395.0', '2405.0', '2415.0', '2425.0', '2435.0', '2445.0', '2455.0', '2465.0', '2475.0', '2485.0', '2495.0']
  }),
  methods: {
    showDialog(){
      this.setLucasData()
      this.$store.commit("app/SET_LUCAS_DIALOG", true)
    },
    setLucasData(){
      const y = this.wavelength.map(x => this.properties[x] * 100)
      const data = {
        x: this.wavelength,
        y: y
      }
      this.$store.commit("app/SET_LUCAS_DATA", data)
    }
  }
}
</script>

<style scoped>
.scroll {
   overflow-y: scroll
}
</style>

<style>
.mapboxgl-popup-content {
  padding: 0;
}

.mapboxgl-popup {
  max-width: 400px !important;
}
</style>